// components\partials\app\missions\user-referrals\user-referrals-leaderboard.jsx
import dynamic from 'next/dynamic';

import React, { useEffect, useState } from "react";
import { Fragment } from "react";
const LogoLoading = dynamic(() => import('@/components/ui/LogoLoading'));
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { Icon } from "@iconify/react";
import clipboardCopy from "clipboard-copy";
import { toast } from "react-toastify";
import Image from "next/image";
import { getShowLeaderboardIssueMessageFlag } from "@/utils/firebaseFunctions";

export default function UserReferralsLeaderboard({ leaderboard, leaderboardLoading, userReferralsLeaderboardRecordLoading, leaderboardTabChange, leaderboardHandleNext, leaderboardHandlePrev, user, userReferrals, pagination, tabIndex, setTabIndex, setPagination }) {
  const [showLeaderboardIssueMessage, setShowLeaderboardIssueMessage] = useState(false);

  const handleCopyToClipboard = (text) => {
    clipboardCopy(text);
    toast.success("Copied to clipboard!");
  };

  useEffect(() => {
    const checkLeaderboardIssueMessageFlag = async () => {
      const showLeaderboardIssueMessageFlag = await getShowLeaderboardIssueMessageFlag();
      setShowLeaderboardIssueMessage(showLeaderboardIssueMessageFlag);
    };

    checkLeaderboardIssueMessageFlag();
  }, []);

  const TabPanelHeader = (type) => {
    return (
      <div className="flex flex-row items-stretch justify-start w-full mb-4 pl-2 pr-1">
        <div className="text-white text-sm gothamMedium w-16 flex items-center">Rank</div>
        <div className="text-white text-sm gothamMedium flex items-center flex-grow">UID</div>
        <div className="text-white text-sm gothamMedium w-24 flex items-center">{type === "signups" ? "Signups" : "Active"}</div>
      </div>
    );
  };

  const TabPanelUserReferrals = (user, userReferrals, activeIndex) => {
    return (
      <Fragment>
        {user ? (
          <Fragment>
            {!userReferrals && (
              <div className="flex flex-col items-stretch justify-start w-full mb-4">
                <div className="flex flex-row items-stretch justify-start w-full bg-metaxseed-orange rounded-lg py-1 pl-2 pr-1">
                  <div className="py-1 text-white text-sm gothamMedium w-16 flex items-center">You</div>
                  <div className="py-1 text-white text-sm gothamBook flex items-center flex-grow">
                    {user.photo_url ? <Image src={user.photo_url} className="w-6 h-6 mr-2 rounded-full bg-black-500" alt="User Pfp" width={200} height={200} /> : <Image src="https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/branding%2Fmxs_games%2Fv1%2Fwhite%2Fpng%2Fmxs_icon_white.png?alt=media&token=8a7e36ba-954b-46b3-bcb2-559cec885bdf" className="w-6 h-6 mr-2 rounded-full bg-black-500" alt="User Pfp" width={200} height={200} />}
                    <span>{(user.uid.length > 6 ? user.uid.substring(0, 3) + "..." + user.uid.substring(user.uid.length - 3, user.uid.length) : user.uid)}</span>
                    <button onClick={() => handleCopyToClipboard(user.uid)} className="cursor-pointer text-zinc-400 dark:text-zinc-600 hover:text-zinc-600 dark:hover:text-zinc-400 ml-2">
                      <Icon icon="solar:copy-linear" className="text-metaxseed-gray" />
                    </button>
                  </div>
                  <div className="py-1 px-2 text-white text-sm gothamMedium rounded-lg w-24 flex items-center bg-metaxseed-content-gray">
                    <Icon icon="fa-solid:user-plus" className="w-5 h-5 mr-2" />0
                  </div>
                </div>
              </div>
            )}
            {userReferrals && (
              <div className="flex flex-col items-stretch justify-start w-full mb-4">
                <div className="flex flex-row items-stretch justify-start w-full bg-metaxseed-orange rounded-lg py-1 pl-2 pr-1">
                  <div className="py-1 text-white text-sm gothamMedium w-16 flex items-center">#{userReferrals.rank}</div>
                  <div className="py-1 text-white text-sm gothamBook flex items-center flex-grow">
                    {user.photo_url ? <Image src={user.photo_url} className="w-6 h-6 mr-2 rounded-full bg-black-500" alt="User Pfp" width={200} height={200} /> : <Image src="https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/branding%2Fmxs_games%2Fv1%2Fwhite%2Fpng%2Fmxs_icon_white.png?alt=media&token=8a7e36ba-954b-46b3-bcb2-559cec885bdf" className="w-6 h-6 mr-2 rounded-full bg-black-500" alt="User Pfp" width={200} height={200} />}
                    <span>{(userReferrals.uid.length > 6 ? userReferrals.uid.substring(0, 3) + "..." + userReferrals.uid.substring(userReferrals.uid.length - 3, userReferrals.uid.length) : userReferrals.uid)}</span>
                    <button onClick={() => handleCopyToClipboard(userReferrals.uid)} className="cursor-pointer text-zinc-400 dark:text-zinc-600 hover:text-zinc-600 dark:hover:text-zinc-400 ml-2">
                      <Icon icon="solar:copy-linear" className="text-metaxseed-gray" />
                    </button>
                  </div>
                  <div className="py-1 px-2 text-white text-sm gothamMedium rounded-lg w-24 flex items-center bg-metaxseed-content-gray">
                    <Icon icon="fa-solid:user-plus" className="w-5 h-5 mr-2" />
                    {userReferrals.value}
                  </div>
                </div>
              </div>
            )}
          </Fragment>
        ) : null}
      </Fragment>
    );
  };

  const TabPanelBody = (user, leaderboard, activeIndex) => {
    return (
      <Fragment>
        <div className="flex flex-col items-stretch justify-start w-full">
          {leaderboard?.map((user, index) => (
            <div key={index} className="flex flex-row items-stretch justify-start w-full mb-1 bg-metaxseed-dark-gray rounded-lg py-1 pl-2 pr-1">
              <div className="py-1 text-white text-sm gothamMedium w-16 flex items-center">
                #{user.rank}
              </div>
              <div className="py-1 text-white text-sm gothamBook flex items-center flex-grow">
                {user.userDetails && user.userDetails.photo_url ? <Image src={user.userDetails.photo_url} className="w-6 h-6 mr-2 rounded-full bg-black-500" alt="User Pfp" width={200} height={200} /> : <Image src="https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/branding%2Fmxs_games%2Fv1%2Fwhite%2Fpng%2Fmxs_icon_white.png?alt=media&token=8a7e36ba-954b-46b3-bcb2-559cec885bdf" className="w-6 h-6 mr-2 rounded-full bg-black-500" alt="User Pfp" width={200} height={200} />}
                <span>
                  {(user.uid.length > 6 ? user.uid.substring(0, 3) + "..." + user.uid.substring(user.uid.length - 3, user.uid.length) : user.uid)}
                </span>
                <button onClick={() => handleCopyToClipboard(user.uid)} className="cursor-pointer text-zinc-400 dark:text-zinc-600 hover:text-zinc-600 dark:hover:text-zinc-400 ml-2">
                  <Icon icon="solar:copy-linear" className="text-metaxseed-gray" />
                </button>
              </div>
              <div className="py-1 px-2 text-white text-sm gothamMedium rounded-lg w-24 flex items-center bg-metaxseed-content-gray">
                <Icon icon="fa-solid:user-plus" className="w-5 h-5 mr-2" />
                {user.value}
              </div>
            </div>
          ))}
        </div>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <Fragment>
        <div className="flex flex-col items-start justify-stretch">
            {showLeaderboardIssueMessage && (
              <div className="gothamBook w-full text-xs text-metaxseed-gray text-center mb-4">
                    <p className="mb-0">Our leaderboards are temporarily experiencing issues.</p>
                    <p className="mb-0">The data displayed may be incorrect.</p>
                    <p className="mb-0">Unusual points activity is being audited.</p>
                    <p className="mb-0">Thank you for your patience.</p>
              </div>
            )}

          <Tabs
            className={"leaderboardTabs flex flex-col flex-grow w-full"}
            selectedIndex={tabIndex}
            disabled={leaderboardLoading || !leaderboard || userReferralsLeaderboardRecordLoading}
            onSelect={(index) => {
              setTabIndex(index);
              leaderboardTabChange(index, 1, setPagination);
            }}
          >
            <TabList className="flex flex-row items-stretch justify-between w-full mb-4">
              <Tab className={"mr-0 p-0 flex flex-grow flex-1"}>
                <button className="gothamMedium text-lg rounded-t-lg text-white bg-metaxseed-blue flex flex-1 items-center justify-center py-1 px-4 mr-1">Signups</button>
              </Tab>
              <Tab className={"mr-0 p-0 flex flex-grow flex-1"}>
                <button className="gothamMedium text-lg rounded-t-lg text-white bg-metaxseed-blue flex flex-1 items-center justify-center py-1 px-4 mr-1">Active</button>
              </Tab>
            </TabList>

            <TabPanel>
              {leaderboardLoading || userReferralsLeaderboardRecordLoading ? (
                <div className="flex items-center justify-center py-16">
                  <LogoLoading />
                </div>
              ) : (
                <Fragment>
                  <TabPanelHeader type="signups" />

                  {TabPanelUserReferrals(user, userReferrals, 0)}

                  {TabPanelBody(user, leaderboard, 0)}
                </Fragment>
              )}
            </TabPanel>
            <TabPanel>
              {leaderboardLoading || userReferralsLeaderboardRecordLoading ? (
                <div className="flex items-center justify-center py-16">
                  <LogoLoading />
                </div>
              ) : (
                <Fragment>
                  <TabPanelHeader />

                  {TabPanelUserReferrals(user, userReferrals, 1)}

                  {TabPanelBody(user, leaderboard, 1)}
                </Fragment>
              )}
            </TabPanel>
          </Tabs>

          {!leaderboardLoading && !userReferralsLeaderboardRecordLoading && leaderboard && (
            <div className="flex justify-stretch items-stretch w-full mt-4 gap-x-2">
              <button
                className={`gothamMedium text-white rounded-lg py-1 px-4 flex flex-1 justify-center items-center ${
                  pagination.hasPrev ? "bg-metaxseed-blue" : "bg-metaxseed-gray"
                }`}
                disabled={!pagination.hasPrev}
                onClick={() => {
                  if (pagination.hasPrev) {
                    leaderboardHandlePrev(pagination.currentPage - 1);
                    setPagination(prev => ({
                      ...prev,
                      currentPage: prev.currentPage - 1
                    }));
                  }
                }}
              >
                <Icon icon="ph:caret-left-bold" className="text-xl" />
              </button>

              <button
                className={`gothamMedium text-white rounded-lg py-1 px-4 flex flex-1 justify-center items-center ${
                  pagination.hasNext ? "bg-metaxseed-blue" : "bg-metaxseed-gray"
                }`}
                disabled={!pagination.hasNext}
                onClick={() => {
                  if (pagination.hasNext) {
                    leaderboardHandleNext(pagination.currentPage + 1);
                    setPagination(prev => ({
                      ...prev,
                      currentPage: prev.currentPage + 1
                    }));
                  }
                }}
              >
                <Icon icon="ph:caret-right-bold" className="text-xl" />
              </button>
            </div>
          )}
        </div>
      </Fragment>
    </Fragment>
  );
}
